// extracted by mini-css-extract-plugin
module.exports = {"selectionsCards":"_3koFn","selectionsCardContent":"_3dGWh","title":"_3ZrgJ"};